"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const API_HOST = process.env.JB_API_HOST || "https://api.justblink.com.pl";
const UserLicenceAPI = {
    baseURL: API_HOST,
    getUsersWithLicences: (token, groupName) => {
        // eslint-disable-next-line no-undef
        return fetch(`${UserLicenceAPI.baseURL}/users?groupName=${groupName}`, {
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        });
    },
    getUsersGroups: (token) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/groups`, {
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        });
    },
    getUserGroup: (token, userId) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/${userId}/groups`, {
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        });
    },
    updateLicence: (token, userId, licence) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/${userId}/licences/${licence.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(licence),
        });
    },
    createLicence: (token, userId, licence) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/${userId}/licences`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(licence),
        });
    },
    getUserLicence: (token, userId) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/${userId}/licences`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getAllLicences: (token) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/licences`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
    },
    deleteUserLicence: (token, userId, licenceId) => {
        return fetch(`${UserLicenceAPI.baseURL}/users/${userId}/licences/${licenceId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
    },
};
exports.default = UserLicenceAPI;
